var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.1,15.8C70.3-5,36.4-5,15.6,15.8c-20.8,20.8-20.8,54.6,0,75.5l228.9,228.7L15.8,548.9c-20.8,20.8-20.8,54.6,0,75.5,20.8,20.8,54.6,20.8,75.5,0l228.7-228.9,228.9,228.7c20.8,20.8,54.6,20.8,75.5,0,20.8-20.8,20.8-54.6,0-75.5l-228.9-228.7,228.7-228.9c20.8-20.8,20.8-54.6,0-75.5-20.8-20.8-54.6-20.8-75.5,0l-228.7,228.9L91.1,15.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmark);
export default __webpack_public_path__ + "static/media/xmark.dfe30f7b61c15c5a07e436096233a794.svg";
export { ForwardRef as ReactComponent };